var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 80.708C62.0914 80.708 80 62.6409 80 40.354C80 18.0671 62.0914 0 40 0C17.9086 0 0 18.0671 0 40.354C0 62.6409 17.9086 80.708 40 80.708Z",
    fill: "#ECEFF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1052 63.9554C67.3652 62.5682 65.2452 61.5695 62.9452 61.0852L51.9802 58.8658C50.8302 58.6388 50.0002 57.5997 50.0002 56.3941V53.5189C60.9252 52.4646 62.5002 50.2149 62.5002 47.9197C62.5002 41.1352 58.0302 25.382 57.2952 22.8196C57.2002 18.8598 56.4852 16.6353 54.6902 14.6832C53.4202 13.296 51.5502 12.9732 50.0452 12.7159C49.4552 12.61 48.6402 12.4738 48.3402 12.3074C45.6752 10.8546 43.0402 10.1484 39.8952 10.0879C33.3102 10.3603 25.2152 14.5874 22.4452 22.3151C22.2452 23.0365 17.5002 40.0961 17.5002 47.9197C17.5002 51.1834 21.1552 52.9035 30.0002 53.6904V56.3941C30.0002 57.5997 29.1652 58.6388 28.0102 58.8658L17.0352 61.0852C14.7502 61.5745 12.6302 62.5632 10.8952 63.9504C10.3552 64.3892 10.0152 65.0298 9.96015 65.7259C9.90515 66.422 10.1352 67.103 10.6002 67.6226C18.0702 75.9405 28.7852 80.7074 40.0002 80.7074C51.2152 80.7074 61.9352 75.9405 69.4002 67.6226C69.8652 67.103 70.1002 66.417 70.0402 65.7209C69.9852 65.0298 69.6452 64.3892 69.1052 63.9554Z",
    fill: "#2EBBEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleIcon);
export default __webpack_public_path__ + "static/media/femaleIcon.01c5630b63ba21ede8576dc49feb6dd3.svg";
export { ForwardRef as ReactComponent };